import { useState } from 'react';

const useCheckList = () => {
  const [checkedIdList, setCheckedIdList] = useState<number[]>([]);

  const checkItem = (id: number, isCheck: boolean) => {
    if (isCheck) {
      const result = [...checkedIdList, id].sort();
      setCheckedIdList(result);
    } else {
      const result = checkedIdList.filter((element) => element !== id);
      setCheckedIdList(result);
    }
  };

  return {
    checkedIdList,
    setCheckedIdList,
    checkItem,
  };
};

export default useCheckList;
